<template>
  <div>
    <label class="radio-container" @change="saveSetting($event)">{{props.label ? props.label : null}}
      <input type="radio" :data-value="props.value" :name="props.name" :checked="props.checked" :aria-labelledby="props.labelledBy">
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script setup>
//Utilities
import { defineProps, defineEmits } from 'vue'
import axios from 'axios'
import * as lst from '@/components/localStorage.js'

const props = defineProps({
  label: String,
  checked: Boolean,
  name: String,
  value: String,
  labelledBy: String
})

const emit = defineEmits(['settingSaved'])

function saveSetting (event) {
  //Get the data-value attribute on the radio element
  let choice = event.target.dataset.value

  //POst it to db
  axios.post('/timetable/settings', {}, {
    params: {
      settingName: props.name,
      settingValue: choice
    }
  })
  .catch(function (error) {
    console.log(error.toJSON());
  })
  .then(response => {
    //Display settings saved message
    if(response && response.status === 200) {
      lst.setValue('timetableDefaultView', choice)
      emit('settingSaved')
    }
  })
}

</script>

<style scoped lang="scss">
/* The container */
.radio-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 26px;
  width: 26px;
  background-color: #D9D9D9;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
  background-color: var(--uog-dark-blue);
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: block;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
  background: var(--uog-blue-10);
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
 	top: 4px;
	left: 4px;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: #fff;
}

/*keyboard focus*/
.radio-container input:focus-visible + .checkmark {
    outline: solid 3px #FFDD00;
}
</style>
